/* These lines of code are defining constants for action types in a Redux application. */
export const LIST_ALL_FRAME_MATERIALS_SUCCESS =
  'LIST_ALL_FRAME_MATERIALS_REQUEST_SUCCESS';
export const LIST_ALL_FRAME_MATERIALS_REQUEST =
  'LIST_ALL_FRAME_MATERIALS_REQUEST';
export const LIST_ALL_FRAME_MATERIALS_FAILURE =
  'LIST_ALL_FRAME_MATERIALS_FAILURE';
